import React, { useState, useEffect, Fragment } from "react";
import { Button, Image, Row, Col, Form } from "react-bootstrap";
// import Switch from "react-switch";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
// import InputNumberFunc from "../../../../function/InputNumberFunc";
import { makeStyles } from "@material-ui/core";
// import AddOfferOfflineVendor from "../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOfflineVendor";
// import AddOfferOnlineVendor from "../../../vendorDashboardComponents/offers/AddOfferScreen/AddOfferOnlineVendor";
// import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
// import { PopupIconButtonReusable } from "../../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import SendSmsNew from "../../../reusableComponents/allPopupReusable/SendSmsNew";
// import NotificationsNew from "../../../reusableComponents/allPopupReusable/NotificationsNew";
// import { PopupInsideButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
// import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
// import {
//   InputBoxComponent,
//   NewInputText,
// } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { TextField, FormControl, Select } from "@material-ui/core";
// import hi from "../../../../../src/assets/images/UserManagement/eye.svg";
import NewCountDown from "../../../reusableComponents/allPopupReusable/tableNumberPopup/NewCountDown";
import moment from "moment";
import { useDispatch, connect } from "react-redux";
import {
  cancel_item_order,
  debit_memo_order_cancel_item,
} from "../../../../store/actions/OrderingAction/vendorOrderingAction";
import {
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
} from "../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  CREATE_ORDER_VENDOR,
  SELECTED_SUBSTITUTE_ITEM,
  SUBSTITUTE_EXISTING_RECORDS,
} from "../../../../store/types";
import PropTypes from "prop-types";
import { PopupInsideButton } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { ITEMTYPEVEG, NEW_PAYMENT_TYPE } from "../../../../enums/OrderEnums";
import {
  calcFinalTotalEdit,
  calcTotalOriginalEdit,
} from "../../../../function/ordering";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const ViewMobileOrder = (props) => {
  const classes = useStyles();
  //state
  const [selectedTab, setSelectedTab] = useState(1);
  const handleTab = (e) => {
    setSelectedTab(e);
  };
  const [checked, setChecked] = useState(false);
  const toggleFunction = (e) => {
    setChecked({ checked: !checked.checked });
  };
  const [state, setState] = useState({
    country: "",
    restaurant: "",
    state: "",
    City: "",
    open: false,
  });
  const selecthandleChange = (e) => {
    setState({ [e.target.name]: e.target.value });
  };
  const onOpenModal = () => {
    setState({
      open: true,
    });
  };
  const onCloseModal = () => {
    setState({
      open: false,
    });
  };

  useEffect(() => {
    if (props?.openViewWhenScan) {
      onOpenModal();
      props.resetopenViewWhenScan();
    }
  }, [props?.openViewWhenScan]);

  const createdAt = new Date(props.orderDetails.createdAt);
  const updatedTime = moment(
    props?.orderDetails?.max_time_date || props?.orderDetails?.OrderAcceptTime
  ).add(parseInt(props.orderDetails?.max_time), "minutes");
  let diff = updatedTime.diff(moment());

  const calcDate = () => {
    return props.orderDetails?.later_date || props.orderDetails?.createdAt;
  };

  const [cookLevels, setCookLevels] = useState({
    spice: 4,
    sugar: 4,
    salt: 5,
    fat: 5,
    meat: 5,
    egg: 5,
  });

  const prepareLevels = (data) => {
    let levelNames = [];

    if (data.spice_level) {
      let spice = "Spice : " + data.spice_level.level + "/" + cookLevels.spice;
      levelNames.push(spice);
    }

    if (data.salt_level) {
      let salt = "Salt : " + data.salt_level.level + "/" + cookLevels.salt;
      levelNames.push(salt);
    }

    if (data.sugar_level) {
      let sugar = "Sugar : " + data.sugar_level.level + "/" + cookLevels.sugar;
      levelNames.push(sugar);
    }

    if (data.fat_level) {
      let fat =
        "fat/oil/fried : " + data.fat_level.level + "/" + cookLevels.fat;
      levelNames.push(fat);
    }

    if (data.meat_cook_level) {
      let meat = "Meat : " + data.meat_cook_level.level + "/" + cookLevels.meat;
      levelNames.push(meat);
    }

    if (data.egg_cook_level) {
      let egg = "Egg : " + data.egg_cook_level.level + "/" + cookLevels.egg;
      levelNames.push(egg);
    }
    return levelNames.toString();
  };
  const calcItemsLength = () => {
    let count = 0;
    for (let i = 0; i < props.orderDetails.order_items.length; i++) {
      if (
        props.orderDetails.order_items[i].isSubstituted ||
        props.orderDetails.order_items[i].isCancelled
      ) {
      } else {
        count += 1;
      }
    }
    return count;
  };
  const [showSubstitute, setShowSubstitute] = useState(false);
  const [substituteItemData, setSubstituteItemData] = useState({});
  const [orderId, setOrderId] = useState();
  const [itemIndex, setItemIndex] = useState();
  const [subType, setSubType] = useState("Substitute");
  const handleCloseSubstitute = () => {
    setShowSubstitute(false);
  };

  const onClickShowSubstituteModal = (itemData, id, index) => {
    setShowSubstitute(true);
    setSubstituteItemData(itemData);
    setOrderId(id);
    setItemIndex(index);
  };

  const [showHoldOrder, setShowHoldOrder] = useState(false);

  const handleCloseHoldOrder = () => {
    setShowHoldOrder(false);
  };
  //Model order view
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });
  const dispatch = useDispatch();
  const [vtype, viewType] = useState(3);
  const handleClickConfirm = () => {
    if (subType === "Substitute") {
      viewType(5);
      viewOrderInDetail();
      handleCloseSubstitute();
      let orderSelected = "";
      if (props.orderDetails.order_type === 0) {
        orderSelected = "take_away";
      } else if (props.orderDetails.order_type === 1) {
        orderSelected = "curb_side";
      } else if (props.orderDetails.order_type === 2) {
        orderSelected = "skip_line";
      } else if (props.orderDetails.order_type === 3) {
        orderSelected = "dine_in";
      } else if (props.orderDetails.order_type === 7) {
        orderSelected = "home_delivery";
      }

      let existingData = JSON.parse(JSON.stringify(props.orderDetails));
      existingData.orderSelected = orderSelected;
      existingData.selectedTabId = 1;

      // dispatch({
      //   type: SELECTED_SUBSTITUTE_ITEM,
      //   payload: substituteItemData,
      // });
      dispatch({ type: CREATE_ORDER_VENDOR, payload: existingData });
    } else {
      // console.log(orderId);
      // console.log(substituteItemData);

      if (props.orderDetails.payment_method !== 0) {
        let addOnsTotal = 0;
        for (let i = 0; i < substituteItemData.addOns.length; i++) {
          for (
            let j = 0;
            j < substituteItemData.addOns[i].options.length;
            j++
          ) {
            addOnsTotal += parseInt(
              substituteItemData.addOns[i].options[j].price
            );
          }
        }
        let taxes = 0;
        let tempTotal = substituteItemData.size.price + addOnsTotal;
        for (let i = 0; i < substituteItemData.sur_charges.length; i++) {
          if (substituteItemData.sur_charges[i].flag === "PERCENTAGE") {
            taxes +=
              parseFloat(tempTotal * substituteItemData.sur_charges[i].value) /
              100;
          } else {
            taxes += tempTotal + substituteItemData.sur_charges[i].value;
          }
        }

        let amount = tempTotal;

        const formData = {};
        formData.amount = (amount + taxes) * substituteItemData.quantity;
        formData.order_id = orderId;
        formData.items = [];
        formData.items.push(substituteItemData);
        formData.items[0].isCancelled = true;

        const token = props.auth.user.accessToken;
        props.debit_memo_order_cancel_item(token, formData, onSuccess);
      } else {
        onSuccess();
      }
    }
  };

  const onSuccessfinal = () => {};

  // const onSuccess = (memoId) => {
  //   // console.log(itemIndex);
  //   // console.log(orderId);
  //   // console.log(props.orderDetails.order_items);

  //   const existingData = { ...props.orderDetails };
  //   const itemToCheck = existingData.order_items[itemIndex];
  //   itemToCheck.isCancelled = true;
  //   //let finalPriceIncluingTaxes = 0;
  //   //let taxesToDeduct = 0;
  //   let addOns = 0;
  //   let priceInCludingAddons = 0;
  //   for (let i = 0; i < itemToCheck.addOns.length; i++) {
  //     for (let j = 0; j < itemToCheck.addOns[i].options.length; j++) {
  //       addOns += parseInt(itemToCheck.addOns[i].options[j].price);
  //     }
  //   }
  //   priceInCludingAddons +=
  //     (itemToCheck.size.price + addOns) * itemToCheck.quantity;
  //   existingData.base_amount = existingData.base_amount - priceInCludingAddons;
  //   let taxesCode = {};
  //   for (let i = 0; i < itemToCheck.sur_charges.length; i++) {
  //     if (itemToCheck.sur_charges[i].flag === "PERCENTAGE") {
  //       //taxesCode[itemToCheck.sur_charges[i].name?.split('-')[0].trim()]+=
  //       let calPer =
  //         (priceInCludingAddons * itemToCheck.sur_charges[i].value) / 100;
  //       taxesCode[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = calPer;
  //       existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = parseFloat(
  //         existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //         ] - calPer
  //       ).toFixed(2);
  //       existingData.total_amount = existingData.total_amount - calPer;
  //     } else {
  //       taxesCode[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] = (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //       existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //       ] =
  //         existingData.gstAmount[
  //         itemToCheck.sur_charges[i].code ||
  //         itemToCheck.sur_charges[i].name?.split("-")[0].trim()
  //         ] - (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //       existingData.total_amount =
  //         existingData.total_amount - (itemToCheck.sur_charges[i].value * itemToCheck.quantity);
  //     }
  //   }

  //   existingData.total_amount = parseFloat(
  //     existingData.total_amount - priceInCludingAddons
  //   ).toFixed(2);
  //   const formData = {};
  //   formData.order_id = orderId;
  //   if (existingData.payment_method === 0) {
  //   } else {
  //     formData.memoId = memoId;
  //   }
  //   formData.order_items = existingData.order_items;
  //   formData.total_amount = existingData.total_amount;
  //   formData.base_amount = existingData.base_amount;
  //   formData.gstAmount = existingData.gstAmount;
  //   const token = props.auth.user.accessToken;

  //   let cancelledCount = 0;
  //   for (let i = 0; i < formData.order_items.length; i++) {
  //     if (formData.order_items[i].isCancelled || formData.order_items[i].isSubstituted) {
  //       cancelledCount += 1;
  //     }
  //   }
  //   if (cancelledCount === formData.order_items.length) {
  //     formData.order_status = 8;
  //     formData.total_amount = 0;
  //     formData.base_amount = 0;
  //     formData.gstAmount = {};
  //   }
  //   props.cancel_item_order(token, formData, onSuccessfinal);
  // };

  const onSuccess = (memoId) => {
    try {
      const existingData = { ...props.orderDetails };
      const itemToCheck = existingData.order_items[itemIndex];
      itemToCheck.isCancelled = true;
      let newOrderData = existingData.order_items.filter(
        (ele, i) => !((ele.isSubstituted || ele.isCancelled) && itemIndex !== i)
      );
      const formData = {};
      formData.order_items = existingData.order_items;
      let orderData = calcFinalTotalEdit(
        formData.order_items,
        props.orderDetails,
        props.subscription
      );
      formData.total_amount = orderData.total;
      formData.base_amount = calcTotalOriginalEdit(formData.order_items);
      let taxesArr = [];
      formData.gstAmount = orderData.taxes.gst;
      formData.surCharges = orderData.taxes.surCharges;
      formData.order_id = existingData._id;
      const token = props?.auth?.user.accessToken;
      let cancelledCount = 0;
      for (let i = 0; i < formData.order_items.length; i++) {
        if (
          formData.order_items[i].isCancelled ||
          formData.order_items[i].isSubstituted
        ) {
          cancelledCount += 1;
        }
      }
      if (cancelledCount === formData.order_items.length) {
        formData.order_status = 8;
        formData.total_amount = 0;
        formData.base_amount = 0;
        formData.gstAmount = {};
      }
      props.cancel_item_order(token, formData, onSuccessfinal);
    } catch (error) {
      console.log("error :>> ", error);
    }
  };

  const onClickHoldOrder = () => {
    const formData = { onhold: true, id: props.orderDetails._id };
    props.onUpdateOrderStatus(formData);
  };

  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3 action_icon_padding"
        onClick={onOpenModal}
      >
        <Image
          src={require("../../../../../src/assets/images/UserManagement/eye.svg")}
          alt="Edit"
          title="Edit"
          fluid
        />
      </Button>{" "}
      <Modal
        open={state.open}
        onClose={onCloseModal}
        center
        classNames={{
          overlay: "customOverlay-request-accept-cancelled",
          modal: "offer-event-main closeRemove min-height-100vh w-100",
          animationIn: "customEnterAnimation",
          animationOut: "customLeaveAnimation",
        }}
        animationDuration={1000}
      >
        <div className="d-flex align-items-center py-3 px-4 border-bottom">
          <span className="pr-3 cursor" onClick={onCloseModal}>
            <Image
              alt="Back"
              width="20px"
              src={require("../../../../../src/assets/images/UserManagement/backIcon.svg")}
            />
          </span>
          <div className="f12-400 c_black">View Order Details</div>
        </div>
        <div className="superadmin-orderscomponent-main">
          {/* <div className="container-fluid" style={{ marginBottom: "2%" }}>
            <Row>
              <Col md={6}>
                <h5>Order Name: Alexander Petersburg</h5>
              </Col>
              <Col md={6}>
                <h5>
                  Order Type:{" "}
                  <span className="badge badge-warning">Take Away</span>
                </h5>
              </Col>
            </Row>
          </div> */}

          <div
            className="model-head-view-order-detailed "
            style={{
              border: "1px solid #E0E0E0",
              padding: "1%",
              borderRadius: "5px 0px 0px 5px",
            }}
          >
            <div
              style={{
                borderRadius: "5px",
                borderLeft: "5px solid #37ac1e",
                paddingLeft: "1%",
              }}
            >
              <div className="model-view-order-detailed-table">
                <div className="d-flex">
                  <div className="col-2 f12-500 opacity5">Order Type</div>
                  <div className="col-3 f12-500 opacity5 p-0">
                    Name &<br /> Request No.
                  </div>
                  <div className="col-2 f12-500 opacity5 p-0">No. Items</div>
                  <div className="col-3 f12-500 opacity5 p-0">
                    Amount / Payment
                  </div>
                  <div className="col-2 f12-500 opacity5 p-0">
                    Ordeing Preference
                  </div>
                </div>
                <div style={{ marginTop: "1%" }}>
                  <div className="d-flex model-view-order-detailed-table">
                    <div className="col-2">
                      <img
                        src={
                          props.orderDetails &&
                          props.orderDetails.order_type === 0
                            ? require("../../../../assets/images/superadmin/ordericon/takeaway.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 1
                            ? require("../../../../assets/images/superadmin/ordericon/curb side.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 3
                            ? require("../../../../assets/images/superadmin/ordericon/dine in.svg")
                            : props.orderDetails &&
                              props.orderDetails.order_type === 2
                            ? require("../../../../assets/images/superadmin/ordericon/skip the line.svg")
                            : props?.orderDetails?.order_type === 7
                            ? require("../../../../assets/images/superadmin/ordericon/delivery.svg")
                            : ""
                        }
                        width="35px"
                        alt={
                          props.orderDetails &&
                          props.orderDetails.order_type === 0
                            ? "takeaway"
                            : props.orderDetails &&
                              props.orderDetails.order_type === 1
                            ? "curb side"
                            : props.orderDetails &&
                              props.orderDetails.order_type === 3
                            ? "dine in"
                            : ""
                        }
                      />
                      {/* <img
                        src={require("../../../../assets/images/superadmin/ordericon/takeaway.svg")}
                        width="35px"
                        alt="Takeaway"
                      /> */}
                    </div>
                    <div className="col-3 f12-500 p-0">
                      {props.orderDetails &&
                      props.orderDetails.user_details &&
                      props.orderDetails.user_details.first_name &&
                      props.orderDetails.user_details.last_name
                        ? props.orderDetails.user_details.first_name +
                          " " +
                          props.orderDetails.user_details.last_name
                        : ""}
                      <p style={{ fontSize: ".75rem" }} className="f10-400">
                        #{props.orderDetails && props.orderDetails.order_id}
                      </p>
                    </div>

                    <div className="col-2 f12-500 p-0">
                      {calcItemsLength(props.orderDetails)}
                    </div>
                    <div className="col-3 f12-500 p-0">
                      <i className="fa fa-inr mr-1" aria-hidden="true"></i>
                      {props.orderDetails?.total_amount !== null &&
                      props.orderDetails?.total_amount !== undefined
                        ? props.orderDetails.total_amount.toFixed(2)
                        : ""}
                      <br />
                      <span className="my-2">
                        {props &&
                        props.orderDetails &&
                        props.orderDetails.payment_status === 1 ? (
                          <span className="badge badge-success"> PAID</span>
                        ) : props &&
                          props.orderDetails &&
                          props.orderDetails.payment_status === 0 ? (
                          <span className="badge badge-danger"> UNPAID</span>
                        ) : props.orderDetails.payment_status === 3 ? (
                          <span className="badge badge-danger"> FAILURE</span>
                        ) : (
                          "N/A"
                        )}
                      </span>
                      <br />
                      <span className="f12-500">
                        {/* {props.orderDetails &&
                        props.orderDetails.payment_method === 0
                          ? "COD"
                          : props.orderDetails.payment_method === 1
                          ? "UPI"
                          : props.orderDetails.payment_method === 2
                          ? "Paytm"
                          : props.orderDetails.payment_method === 3
                          ? "Debit Card"
                          : props.orderDetails.payment_method === 4
                          ? "Credit Card"
                          : props.orderDetails.payment_method === 5
                          ? "NetBanking"
                          : props.orderDetails.payment_method === 6
                          ? "Pay Later"
                          : props.orderDetails.payment_method === 7
                          ? "Wallet"
                          : props.orderDetails.payment_method === 8
                          ? "External Wallet"
                          : props.orderDetails.payment_method === 9
                          ? "Cash"
                          : null} */}
                        {props?.orderDetails?.splitPayment ? (
                          <>Split Payment</>
                        ) : (
                          NEW_PAYMENT_TYPE[props?.orderDetails?.payment_method]
                        )}
                      </span>
                    </div>
                    <div className="col-2 f12-500 p-0">
                      {props.orderDetails &&
                      props.orderDetails.order_type === 1 ? (
                        <Fragment>
                          <div>
                            {/* {console.log(props.orderDetails)} */}
                            <p className="f12-500 mb-2">
                              {props.orderDetails &&
                                props.orderDetails?.curb_side_details?.number}
                            </p>
                            <p className="f9-500 opacity5">
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.model}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.make}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details
                                  .vehical_type_value}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details
                                  .vehical_type}
                              {" | "}
                              {props.orderDetails &&
                                props.orderDetails.curb_side_details &&
                                props.orderDetails.curb_side_details.year}
                            </p>
                            <div
                              className="mt-1"
                              style={{
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor: `${
                                  props.orderDetails &&
                                  props.orderDetails.curb_side_details &&
                                  props.orderDetails.curb_side_details.color
                                }`,
                                boxShadow: "0px 4px 8px #00000029",
                              }}
                            ></div>
                          </div>
                        </Fragment>
                      ) : props.orderDetails?.order_type === 3 ||
                        props.orderDetails?.order_type === 2 ? (
                        <Fragment>
                          {props?.orderDetails?.dine_in_details?.table_number}
                        </Fragment>
                      ) : props.orderDetails?.order_type === 7 &&
                        props?.orderDetails?.deliveryAddress ? (
                        <React.Fragment>
                          <a
                            target="_blank"
                            style={{ textDecoration: "none", color: "inherit" }}
                            href={`https://www.google.com/maps/place/${props.orderDetails?.deliveryAddress?.location?.latitude},${props.orderDetails?.deliveryAddress?.location?.longitude}`}
                          >
                            <p className="f10-500 mb-2">
                              {props.orderDetails?.deliveryAddress?.address1}
                            </p>
                          </a>
                          <p className="f10-400 mb-2">
                            {props.orderDetails?.deliveryAddress?.area || ""},{" "}
                            {props.orderDetails?.deliveryAddress?.city || ""}
                          </p>
                        </React.Fragment>
                      ) : (
                        <p>N/A</p>
                      )}
                    </div>
                    {/* <div className="col-3 f12-500"></div> */}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 d-flex">
              <div className="col-8">
                <div className="f12-500 opacity5 mb-2">
                  Req. Date /Time/Timer
                </div>
                <NewCountDown waitNew={diff} />
                <p className="f12-500">
                  {calcDate() && moment(calcDate()).format("Do MMMM YYYY")}
                  <br />
                  {calcDate() && moment(calcDate()).format("hh : mm A")}
                </p>
              </div>
              <div className="col-4">
                <div className="f12-500" style={{ color: "#2196F3" }}>
                  Track User
                </div>
                <div>
                  <img
                    src={require("../../../../assets/images/superadmin/ordericon/location_red.svg")}
                    width="25px"
                    alt="location"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="col-12 d-flex">
              {/* <div className="col-8 d-flex">
                <CallingButtonPopup sendData={props.orderDetails} />
                <Button
                  variant="link"
                  className="enIconBtn mr-3 action_icon_padding"
                  // onClick={() => {
                  // viewType(1);
                  // viewOrderInDetail();
                  // }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/eye.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>{" "}
                <Button
                  variant="link"
                  className="enIconBtn mr-3 action_icon_padding"
                  // onClick={() => {
                  // viewType(2);
                  // viewOrderInDetail();
                  // }}
                >
                  <Image
                    src={require("../../../../assets/images/UserManagement/pencil.svg")}
                    alt="Edit"
                    title="Edit"
                    fluid
                    style={{ margin: "8px" }}
                  />
                </Button>{" "}
                <NotificationsNew
                  // order_id={props.orderDetails._id}
                  // dataSend={props.orderDetails}
                  style={{ minWidth: "25px" }}
                />
                <ChatWindow
                  // data={props.orderDetails}
                  text={"order"}
                  style={{ minWidth: "25px" }}
                />
              </div>*/}
              {/*<div className="col-4">
                <p style={{ fontSize: ".75rem" }}>Total wait time</p>
                <div className="row"> 

                <div
                  //   className="col-5"
                  style={
                    {
                      // background: "#F0F0F0 0% 0% no-repeat padding-box",
                      // borderRadius: "6px",
                    }
                  }
                >
                  <button
                    className="btn btn-secondary w-100"
                    style={{
                      fontSize: ".75rem",
                      background: "#F0F0F0 0% 0% no-repeat padding-box",
                      borderRadius: "6px",
                      color: "#000000",
                    }}
                  >
                    <img
                      src={require("../../../../assets/images/superadmin/ordericon/hourglass.svg")}
                      width="15px"
                      alt="Hour glass"
                    />
                    00 hh : 20 mins
                  </button>
                </div>

                {/* </div> 
              </div>*/}
            </div>
            {/* <hr /> */}
            <div className="col-12 d-flex">
              <div className="col-7">
                <div className="f12-500 opacity5">Order Notes</div>
                <div className="f12-500">
                  {props.orderDetails && props.orderDetails.notes}
                </div>
              </div>
              <div className="col-5">
                <div className="f12-500 opacity5">ETC</div>
                <div className="f12-500">
                  {props.orderDetails &&
                    props.orderDetails.order_items.map((item, index) => (
                      <Fragment key={index}>
                        {!item.isSubstituted ? (
                          <>
                            {/* <div className="f9-400"> */}
                            {item && item.item && item.item.prepTime}{" "}
                            {/* </div> */}
                          </>
                        ) : (
                          <></>
                        )}
                      </Fragment>
                    ))}
                </div>
              </div>
            </div>
            <br />
            <div className="col-12 seating-dashboard-table px-2">
              <div className="row">
                <div className="col-4 f12-500">Order Items</div>
                <div className="col-4 f12-500">Qty/Size</div>
                <div className="col-4 f12-500">Item Status</div>
              </div>
            </div>
            {props.orderDetails &&
              props.orderDetails.order_items.map((item, index) => (
                <OrderItemsList
                  item={item}
                  key={index}
                  index={index}
                  subType={subType}
                  orderDetails={props.orderDetails}
                  onClickShowSubstituteModal={onClickShowSubstituteModal}
                  showSubstitute={showSubstitute}
                  setSubType={setSubType}
                  handleClickConfirm={handleClickConfirm}
                  showHoldOrder={showHoldOrder}
                  handleCloseHoldOrder={handleCloseHoldOrder}
                  onClickHoldOrder={onClickHoldOrder}
                  prepareLevels={prepareLevels}
                />
              ))}
          </div>
          <h4 className="f16-500 my-4 px-2">Transaction Details</h4>
          <br />
          <div className="details-model-orders-view ">
            <table className="table table-borderless">
              <thead style={{ marginBottom: "1%" }}>
                <tr>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Transaction ID
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Amount
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Method
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Payment Status
                  </th>
                  <th className="f12-500" style={{ width: "20%" }}>
                    Date & Time
                  </th>
                </tr>
              </thead>
              <tbody>
                {props?.allData?.transactionDetails.map((item, index) => (
                  <tr key={index}>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.txnId || item?._id}
                    </td>
                    <td
                      className="f14-500 d-flex align-items-center"
                      style={{
                        width: "20%",
                        color:
                          item?.type === "REFUND" && item?.paid
                            ? "#EE3A23"
                            : item?.type !== "REFUND" && item?.paid
                            ? "#1AB61E"
                            : "#EE3A23",
                      }}
                    >
                      <i class="fa fa-rupee"></i> {item?.amount.toFixed(2)}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item && item?.paymentType === 0
                        ? "COD"
                        : item?.paymentType === 1
                        ? "UPI"
                        : item?.paymentType === 2
                        ? "Paytm"
                        : item?.paymentType === 3
                        ? "Debit Card"
                        : item?.paymentType === 4
                        ? "Credit Card"
                        : item?.paymentType === 5
                        ? "NetBanking"
                        : item?.paymentType === 6
                        ? "Pay Later"
                        : item?.paymentType === 7
                        ? "Wallet"
                        : item?.paymentType === 8
                        ? "External Wallet"
                        : item?.paymentType === 9
                        ? "Cash"
                        : "-"}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {item?.type === "REFUND" && item?.paid
                        ? "Refund"
                        : item?.type !== "REFUND" && item?.paid
                        ? "Paid"
                        : "Unpaid"}
                    </td>
                    <td className="f12-400" style={{ width: "20%" }}>
                      {moment(item?.date).format("Do MMMM YYYY, hh:mm a")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <br />
          <div>
            <div className="m-0 p-2" style={{ background: "#F1F1F1" }}>
              <h4 className="f16-500">View Audit Log</h4>
            </div>
            <br />
            <div className="details-model-orders-view">
              <table className="table table-borderless">
                <thead style={{ marginBottom: "1%" }}>
                  <tr>
                    <th className="f12-500" style={{ width: "25%" }}>
                      Date
                    </th>
                    <th className="f12-500" style={{ width: "50%" }}>
                      Comments
                    </th>
                    <th className="f12-500" style={{ width: "25%" }}>
                      Comments By
                    </th>
                  </tr>
                </thead>
                {props.orderDetails.auditLogs.map((item, index) => (
                  <tbody key={index}>
                    <tr>
                      <td className="f10-400" style={{ width: "25%" }}>
                        {moment(item.timestamp).format("MMMM Do YYYY")} <br />{" "}
                        {moment(item.timestamp).format("LT")}
                      </td>
                      <td className="f10-400" style={{ width: "50%" }}>
                        {item.message}
                      </td>
                      <td
                        className="f10-400"
                        style={{ width: "25%", textAlign: "right" }}
                      >
                        {item.initiator}
                      </td>
                    </tr>
                  </tbody>
                ))}
              </table>
            </div>
          </div>
          {/* <div className="d-flex align-items-center justify-content-center pt-5">
            <Button
              variant="outline-secondary"
              className="mr-4 px-5 py-2"
              //   onClick={(e) => this.props.history.push("/superadminorders")}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="px-5  py-2"
              //onClick={(e) => handleShowTab("2")}
              //type="submit"
              //   onClick={() => onClickStepOne()}
            >
              Proceed
            </Button>
          </div> */}
        </div>
      </Modal>
    </React.Fragment>
  );
};

ViewMobileOrder.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  subscription: state.onboarding.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  cancel_item_order,
  debit_memo_order_cancel_item,
  get_menu_items_by_passing_item_id_in_array,
  update_item_menu_setup_without_loader,
})(ViewMobileOrder);

// export default ViewMobileOrder;

const OrderItemsList = (props) => {
  const item = props?.item;
  const [view, setView] = useState(false);

  const getAddOns = (data) => {
    let addOnsNames = [];
    if (data && data[0] && data[0].options) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < data[i].options.length; j++) {
          addOnsNames.push(data[i].options[j].name);
        }
      }
    } else {
      for (let i = 0; i < data.length; i++) {
        addOnsNames.push(data[i].name);
      }
    }
    return addOnsNames.toString();
  };

  return (
    <div>
      {!item.isSubstituted && (
        <div
          className="text-break p-2"
          style={{
            background: "#FFFFFF 0% 0% no-repeat padding-box",
            boxShadow: "0px 3px 6px #6E6E6E21",
            border: "1px solid #E0E0E0",
            borderRadius: "5px",
          }}
        >
          <div className="row" onClick={(e) => setView(!view)}>
            <div className="col-4" style={{ borderRight: "1px solid #E3E3E3" }}>
              {ITEMTYPEVEG.map((type, index) => {
                return (
                  <React.Fragment key={index}>
                    {item?.item?.itemType === type?.value ? (
                      <Image
                        width="8px"
                        src={type.url}
                        alt={type.title}
                        title={type.title}
                        fluid
                      />
                    ) : null}
                  </React.Fragment>
                );
              })}

              <div className="f12-400">{item.item.name}</div>
            </div>
            <div className="col-4" style={{ borderRight: "1px solid #E3E3E3" }}>
              <div className="f12-400">{item.quantity}</div>
            </div>
            <div className="col-4 p-0">
              <div className="btn btn-outline-success">
                {props.orderDetails && props.orderDetails.order_status === 0 ? (
                  "Pending"
                ) : props.orderDetails.order_status === 1 ? (
                  "Confirmed"
                ) : props.orderDetails.order_status === 2 ? (
                  "Getting Prep"
                ) : props.orderDetails.order_status === 3 &&
                  props.orderDetails &&
                  props.orderDetails.order_type === 3 ? (
                  "Food Plating"
                ) : props.orderDetails.order_status === 3 ? (
                  "Packing"
                ) : props.orderDetails.order_status === 4 &&
                  props.orderDetails &&
                  props.orderDetails.order_type === 3 ? (
                  <>
                    Ready for
                    <br /> Dine-in
                  </>
                ) : props.orderDetails.order_status === 4 &&
                  props.orderDetails &&
                  props.orderDetails.order_type === 0 ? (
                  <>
                    Ready for
                    <br /> Take Away
                  </>
                ) : props.orderDetails.order_status === 4 &&
                  props.orderDetails &&
                  props.orderDetails.order_type === 7 ? (
                  <>
                    Ready for
                    <br /> Delivery
                  </>
                ) : props.orderDetails.order_status === 4 ? (
                  <>
                    Ready To
                    <br /> Pick
                  </>
                ) : props.orderDetails.order_status === 5 &&
                  props?.orderDetails?.order_type === 7 ? (
                  "Out for Delivery"
                ) : props.orderDetails.order_status === 5 ? (
                  "On The Way"
                ) : props.orderDetails.order_status === 6 &&
                  props.orderDetails &&
                  props.orderDetails.order_type === 3 ? (
                  "Served"
                ) : props.orderDetails.order_status === 6 ? (
                  "Delivered"
                ) : props.orderDetails.order_status === 7 ? (
                  "Complete"
                ) : props.orderDetails.order_status === 8 ? (
                  "Cancelled"
                ) : null}
              </div>
              <div className="f10-400 mt-2">Current Status</div>
            </div>
          </div>
          {view && (
            <>
              <hr />
              <div className="row">
                <div
                  className="col-4"
                  style={{ borderRight: "1px solid #E3E3E3" }}
                >
                  <div className="f12-500">Customization</div>
                  <div className="f12-400">
                    {item && item.addOns.length > 0 ? (
                      getAddOns(item && item.addOns)
                    ) : (
                      <Fragment>N/A</Fragment>
                    )}
                  </div>
                </div>
                <div
                  className="col-4"
                  style={{ borderRight: "1px solid #E3E3E3" }}
                >
                  <div className="f12-500">Personalization/Item Notes</div>
                  <div className="f12-400">
                    {item && item.customised_details
                      ? props?.prepareLevels(item && item.customised_details)
                      : " "}{" "}
                    {item && item.notes}
                  </div>
                </div>
                <div className="col-4">
                  <div className="f12-500">Size Options</div>
                  <div className="f12-400">
                    <>
                      {item?.size?.description !== undefined &&
                      item?.size?.description !== null &&
                      item?.size?.description !== "" ? (
                        <div className="f10-400 mb-2 d-flex text-capitalize">
                          Size - {item?.size?.description}
                        </div>
                      ) : (
                        ""
                      )}
                      {item?.size?.uom !== undefined &&
                      item?.size?.uom !== null &&
                      item?.size?.uom !== "" ? (
                        <div className="f10-400 d-flex text-capitalize">
                          UOM - {item?.size?.uom}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-3">
                  <div className="f12-500">Amount</div>
                  <div className="f12-400">
                    {" "}
                    ₹ {item && item.size && item.size.price}
                  </div>
                </div>
                <div className="col-3">
                  <div className="f12-500">ETC</div>
                  <div className="f12-400">
                    {item && item.item && item.item.prepTime} Min
                  </div>
                </div>
                <div className="col-3">
                  <div className="f12-500">Counter No.</div>
                  <div className="f12-400">
                    {item && item.item && item.item.counter_number}
                  </div>
                </div>
                <div className="col-3">
                  <div className="f12-500">
                    Substituted/ <br />
                    Cancelled
                  </div>
                  <div className="f12-400">
                    {item.isCancelled ||
                    props.orderDetails.order_status === 8 ? (
                      "Cancelled"
                    ) : props.orderDetails.order_status === 7 ? (
                      "Completed"
                    ) : (
                      <Fragment>
                        <div className="text-center" style={{ width: "80%" }}>
                          <div class="col-12">
                            <img
                              src={require("../../../../assets/images/superadmin/ordericon/uncheck.svg")}
                              width="25px"
                              alt="Substitute"
                              className="mb-2"
                            />
                          </div>
                          <button
                            className="px-2 f10-500 text-white btn"
                            style={{
                              backgroundColor: "#EE3A23",
                              border: "1px solid #FD0D1B",
                              borderRadius: "6px",
                              width: "100%",
                            }}
                            disabled={[2, 3, 4, 5, 6].includes(
                              props?.orderDetails?.order_status
                            )}
                            onClick={() =>
                              props?.onClickShowSubstituteModal(
                                item,
                                props.orderDetails._id,
                                props?.index
                              )
                            }
                          >
                            Substitute/
                            <br />
                            Cancel
                          </button>
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
      <React.Fragment>
        <Modal
          show={props?.showSubstitute}
          onHide={props?.handleCloseSubstitute}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title>Substitute/Cancel</Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Select one relevant option from Below
            <div className="row mt-3">
              {["Substitute", "Cancel Item"].map((data, index) => {
                return (
                  <div className="col-3" key={index}>
                    <PopupInsideButton
                      buttonClass={
                        data === props?.subType
                          ? "status-selected-button-box f14-500 sts_sld_btn_box_a"
                          : "status-selected-button-box f14-500"
                      }
                      buttonText={data}
                      buttonType="button"
                      onClick={() => props?.setSubType(data)}
                    />
                  </div>
                );
              })}
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={() => props?.handleCloseSubstitute()}
              //onClick={handleCloseFlag}
            >
              Back
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={() => props?.handleClickConfirm()}
              //onClick={() => handleFlagUser(props.user._id, props.user.isFlag)}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
        <Modal
          show={props?.showHoldOrder}
          onHide={props?.handleCloseHoldOrder}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to put this order on hold ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={props?.handleCloseHoldOrder}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => props?.onClickHoldOrder()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </div>
  );
};
